module.exports = __webpack_public_path__ + "resources/images/facebookShareExample-7af438c9a051314d7f97b57f8630dc09-cache.png";